import Constants from './constants'

// 生成前端编号
export function genFrontId (prefix = '') {
  return prefix + (new Date().getTime() + Math.round(Math.random() * 1000000))
}

// 获取文件后缀
export function getFileSuffix (fileName) {
  if (fileName.trim().indexOf('.') > -1 && !fileName.trim().endsWith('.')) {
    return fileName.substring(fileName.lastIndexOf('.') + 1).trim()
  }
  return 'none'
}

/**
 * 解析路径
 */
export function parsePath (path) {
  if (path == null || path.trim().length === 0) return []
  const copyPath = path
    .replace(/'\/'/g, '###')
    .replace(/"\/"/g, '###')
    .trim()
  const tokens = copyPath.split('/')
  const realTokens = []
  for (const token of tokens) {
    if (token.trim().length === 0) continue
    realTokens.push(token.replace(/###/g, '\'/\'').trim())
  }
  return realTokens
}

/**
 * 生成属性
 */
export function buildNewProp (prop) {
  const emptyProp = JSON.parse(JSON.stringify(Constants.EMPTY_PROP))
  emptyProp.frontId = genFrontId()
  if (prop != null) {
    for (const key in emptyProp) {
      emptyProp[key] = prop[key] == null ? emptyProp[key] : prop[key]
    }
  }
  return emptyProp
}

/**
 * 构建新模版文件
 */
export function buildNewFile (file = {}) {
  return {
    frontId: file.frontId == null ? genFrontId() : file.frontId,
    id: file.id == null ? null : file.id,
    templateId: file.templateId == null ? null : file.templateId,
    name: file.name == null ? '' : file.name, // 模版名称
    cycle: file.cycle == null ? Constants.GenCycle.GROUP_BUILDING : file.cycle, // 生成周期，默认为组构建
    fileNameExp: file.fileNameExp == null ? '' : file.fileNameExp, // 文件名表达式
    outputPath: file.outputPath == null ? '' : file.outputPath, // 输出路径，从项目根目录起到文件上级目录结束
    enableExp: file.enableExp == null ? '' : file.enableExp, // 启用表达式
    alias: file.alias == null ? '' : file.alias, // 别名
    content: file.content == null ? '' : file.content, // 内容
    url: file.url == null ? '' : file.url, // 预览地址
    type: 'file', // 节点类型为file
    viewType: file.viewType == null ? 'CODE' : file.viewType, // 展示方式
    props: file.props == null || file.props.length === 0 ? [
      buildNewProp()
    ] : file.props,
    __showMenu: false, // 是否展示文件操作菜单
    __tab: 'code', // 展示页签名称，code代码，desc描述，props属性
    __saving: false, // 是否正在保存
    __deleting: false, // 是否正在删除
    __isEdited: file.__isEdited == null ? false : file.__isEdited // 是否已编辑
  }
}

/**
 * 构建模版目录
 */
export function buildNewFolder (folder) {
  return {
    frontId: folder.frontId == null ? genFrontId() : folder.frontId,
    name: folder.name == null ? '' : folder.name, // 目录名称
    cycle: folder.cycle == null ? 'ONCE' : folder.cycle, // 生成周期，默认为组构建
    enableExp: folder.enableExp == null ? '' : folder.enableExp, // 启用表达式
    type: 'folder', // 节点类型为file
    path: folder.path == null ? '' : folder.path, // 全路径
    children: [], // 子节点
    __showMenu: false // 是否展示操作菜单
  }
}

export default {
  getFileSuffix,
  genFrontId,
  parsePath,
  buildNewProp,
  buildNewFile,
  buildNewFolder
}
